import { render, staticRenderFns } from "./ManageTreatmentScreen.vue?vue&type=template&id=ffea284e&scoped=true"
import script from "./ManageTreatmentScreen.vue?vue&type=script&lang=js"
export * from "./ManageTreatmentScreen.vue?vue&type=script&lang=js"
import style0 from "./ManageTreatmentScreen.vue?vue&type=style&index=0&id=ffea284e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea284e",
  null
  
)

export default component.exports